import React, { useEffect } from 'react';

import { compose } from 'redux';
import { connect } from 'react-redux';

import { NamedRedirect } from '../../components/index.js';

import LandingPageContent from './LandingPageContent';

export const LandingPageComponent = props => {
  const { currentUser, isAuthenticated } = props;

  const { email, profile } = (currentUser && currentUser.id && currentUser.attributes) || {};
  const { firstName, lastName, publicData } = profile || {};
  const { tag = '' } = publicData || {};

  useEffect(() => {
    if (typeof window != "undefined") {
      pendo();
    }
  }, [currentUser?.id]);

  const pendo = () => {
    const ACCOUNT_ID = process.env.REACT_APP_PENDO_ACCOUNT_ID;

    if (firstName && lastName && window.pendo && typeof window.pendo.initialize == 'function') {
      window.pendo.initialize({
        visitor: {
          id: currentUser.id.uuid, // Required if user is logged in
          email,        // Recommended if using Pendo Feedback, or NPS Email
          full_name: (firstName + ' ' + lastName),   // Recommended if using Pendo Feedback
          role: tag, // Optional
        },
        account: {
          id: ACCOUNT_ID // Highly recommended, required if using Pendo Feedback
        }
      });
    }
  }

  // Logged-in users skip the marketing landing page and go straight to their
  // owner dashboard (/dashboard/owner).
  if (isAuthenticated) {
    return <NamedRedirect name="EventDashboardPage" params={{ tab: 'owner' }} />;
  }

  return <LandingPageContent currentPage="LandingPage" />;
};

const mapStateToProps = state => {
  const { currentUser } = state.user;
  const { isAuthenticated } = state.auth;
  return { currentUser, isAuthenticated };
};

// Note: it is important that the withRouter HOC is **outside** the
// connect HOC, otherwise React Router won't rerender any Route
// components since connect implements a shouldComponentUpdate
// lifecycle hook.
//
// See: https://github.com/ReactTraining/react-router/issues/4671
const LandingPage = compose(connect(mapStateToProps))(LandingPageComponent);

export default LandingPage;
